//#region Imports
import { SETTINGS_AUTH_APPLE_LOGIN_WEB_REDIRECT_URL } from "@anydo/core";
import { loadAppleId } from "./loaders/loadAppleId";
//#endregion

//#region Types
type ArgsT = {
  platform: "mac" | "web" | "win";
  referrer: string;
  locale: string;
  clientId: string;
  experiments: readonly string[];
};
//#endregion

export async function redirectLoginWithApple({ platform, referrer, locale, clientId, experiments }: ArgsT) {
  const AppleID = await loadAppleId();

  const redirectUri = SETTINGS_AUTH_APPLE_LOGIN_WEB_REDIRECT_URL;
  /**
   * **! Only works in production URL !**
   */
  AppleID.auth.init({
    clientId: "do.any.desktop",
    scope: "name email",
    redirectURI: redirectUri,
    state: btoa(
      JSON.stringify({
        bundle_identifier: "do.any.desktop",
        redirect_uri: redirectUri,
        app_login_uri: window.location.origin,
        platform,
        referrer,
        locale,
        client_id: clientId,
        create_predefined_data: {
          lists: true,
          labels: true,
        },
        requested_experiments: experiments,
      }),
    ),
  });

  AppleID.auth.signIn();
}
